import { createPrefixedRandomID, createRandomID } from '@/utils/random-id';

export const CHAT_CLIENT_INSTANCE_STORAGE_KEY =
  'cueboard.chat.client_instance_id';

function createClientInstanceID() {
  const id = createRandomID();
  return id.startsWith('id-') ? createPrefixedRandomID('client') : id;
}

export function getChatClientInstanceID() {
  if (typeof window === 'undefined') {
    return createClientInstanceID();
  }
  try {
    const existing = window.sessionStorage
      .getItem(CHAT_CLIENT_INSTANCE_STORAGE_KEY)
      ?.trim();
    if (existing) {
      return existing;
    }
    const next = createClientInstanceID();
    window.sessionStorage.setItem(CHAT_CLIENT_INSTANCE_STORAGE_KEY, next);
    return next;
  } catch {
    return createClientInstanceID();
  }
}
